import { proxy } from 'valtio';
import { valtioDevTools } from '@lib/utils/devTools';
import type { LatencySample, NetworkLatencyStatus } from './types';

export type AppStatusState = {
  isOffline: boolean;
  /** Consecutive `network.request.failed` events since last successful latency sample. */
  sequentialFailedRequests: number;
  latencyHistory: LatencySample[];
  currentStatus: NetworkLatencyStatus;
  averageLatencyMs: number | null;
  lastUpdatedMs: number | null;
};

export const appStatusState = proxy<AppStatusState>({
  isOffline: typeof navigator !== 'undefined' ? !navigator.onLine : false,
  sequentialFailedRequests: 0,
  latencyHistory: [],
  currentStatus: 'good',
  averageLatencyMs: null,
  lastUpdatedMs: null,
});

valtioDevTools(appStatusState, 'appStatusState');
